const NEWS = [{
    id: 1,
    severity: 'high',
    text: "Multiple Active DGS identified on 7/20/24 at Buhasa",
    date: "2024-08-08 08:24 AM"
},
{
    id: 2,
    severity: 'medium',
    text: "Overdue corrosion based PCIT recommendation identified on 7/20/24 at Buhasa",
    date: "2024-09-01 08:24 AM"
}]

export const fetchCriticalItemsFromApi = async () => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return NEWS;
}